'use strict';

import { isFunctionalAllowed } from './consent/resolver';
import { execute as voyado } from './analytics/voyado';

if (isFunctionalAllowed()) {
    voyado();
}

